export function closeSkillCenterWeb(vm, source) {
  // 先停止当前 WebView 内的音视频，再通知宿主 App 关闭页面。
  if (typeof document !== "undefined") {
    document.querySelectorAll("audio, video").forEach((media) => media.pause());
  }
  const payload = { source };
  const userAgent = navigator.userAgent;
  const isAndroid =
    userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1;
  const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

  if (isAndroid && vm.$bridge && typeof vm.$bridge.callmethod === "function") {
    vm.$bridge.callmethod("WebAction.closeWeb", payload, () => {});
    return;
  }
  if (isIOS && window.webkit && window.webkit.messageHandlers.closeWeb) {
    window.webkit.messageHandlers.closeWeb.postMessage(payload);
    return;
  }
  window.history.back();
}
